function resistanceEvents() {

  if( $('#previous-lineups').length) {

      $("#prevlineups").on('click', function(event) {

        event.preventDefault();

        var el = $(this);

        if(el.hasClass('active')) {

            $('#previous-lineups').fadeOut(200);
            setTimeout(function() {
              $('#flyer, .flyers').fadeIn(200);
            }, 200);

            el.removeClass("active");

            window.location.hash = '#flyer';

            el.html('View Previous Lineups <span class="fas fa-chevron-right"></span>')

        } else {

            $('#flyer, .flyers').fadeOut(200);
            setTimeout(function() {
              $('#previous-lineups').fadeIn(200);
            }, 200);

            el.addClass("active");

            window.location.hash = '#previous-lineups';

            el.html('View Current Lineup <span class="fas fa-chevron-right"></span>')

        }

        return false;

      });
  }

  if(window.location.hash == '#previous-lineups') {
    $("#prevlineups").trigger('click');
  }



}

